import { useQuery } from '@tanstack/react-query'
import React, { useEffect, useState } from 'react'
import axios from "../../axios"
import Product from "../../Product"
import ProductSkeleton from "../skeleton/ProductSkeleton"
import { useStateValue } from '../../StateProvider'
import FilterModal from "../admin/FilterModal"
let counter=0
const LoadMoreProducts = () => {
  const [{},dispatch]=useStateValue()
  const [hasMore, setHasMore] = useState(true);
  const [itemsPerPage] = useState(8);
  const [products,setProducts]=useState([])
  const [hasFetch,setHasFetch]=useState(true)
  const skeleton=[1,2,3,4]
  const [sortedData,setSortedData]=useState(products)

  useEffect(()=>{
    setSortedData(products)
  },[products])
  useEffect(()=>{
    return()=>{
      counter=0
      dispatch({
        type:"ADMIN_SEARCH_PRODUCTS",
        payload:[]
      })
    }
  },[])
  const loadProducts=async (counter)=>{
    const resp= await axios({
      url:`/products/get/all/?skip=${counter?counter:0}&limit=${itemsPerPage}`,
      method:'get'
    })
    let data=resp.data
    if(resp.data.length<itemsPerPage){
      setHasMore(false)
    }
    dispatch({
      type:'ADMIN_SEARCH_PRODUCTS',
      payload:[...products,...data]
    })
    setProducts((prevData)=>[...prevData, ...resp.data])
    setHasFetch(false)
    return await resp.data
    
  }

  const { isLoading, isError, error,isFetching} = useQuery({
    queryKey: ['load-more-products'],
    queryFn: ()=>loadProducts(counter),
    refetchOnWindowFocus: false,
  }) 

  const loadMore = async () => {
    counter=counter+8
    setHasFetch(true)
    await loadProducts(counter)
  };

  if (isError) {
    return <span>Error: {error.message}</span>
  }

  return (
    <div className='container-fluid'>
      <FilterModal setSortedData={setSortedData}/> {sortedData.length}
      <div className='row'>
        {sortedData&&sortedData.map((item, index) => (
          <div className='col-xl-3 col-lg-4 col-md-4 col-sm-6' key={index}>
                  <Product id={item._id} title={item.title} image={item.image} price={item.price} rating={item.rating} stock={item.stock} active={item.active}
                  />
          </div>
        ))}
      </div>
      <div className='row justify-content-center'>
      {hasFetch &&
            skeleton.map((s,i)=>
              <div className='col-xl-3 col-lg-4 col-md-4 col-sm-6' key={i}>
              <ProductSkeleton/>
              </div>
          )
        }
      {hasMore && !isLoading && !hasFetch&& (
        <button className='mt-2 mb-2' onClick={()=>loadMore()}>Load More</button>
      )}
      </div>
      <div className='row justify-content-center'>
      {!hasMore && <div className='mt-2 mb-2'>No more items to load.</div>}
      </div>
    </div>
  )
}

export default LoadMoreProducts
